const INITIAL_STATE = {
  estado: 'EXPANDIDO'
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'AREALATERAL_CONTRAIR': {
      return {
        ...state,
        estado: 'CONTRAIDO'
      }
    }
    case 'AREALATERAL_EXPANDIR': {
      return {
        ...state,
        estado: 'EXPANDIDO'
      }
    }
    default: {
      return state
    }
  }
}